import { Star } from 'lucide-react'
import { cn } from '@/lib/utils'

const DefaultPlanStar = ({ className }: { className?: string }) => (
  <Star
    className={cn('h-3.5 w-3.5 shrink-0 text-subscription-gold', className)}
    fill='currentColor'
  />
)

export default DefaultPlanStar
